<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="trash-can">
        <g clip-path="url(#clip0_17177_46035)">
            <path
                d="M5.5 6C5.63261 6 5.75979 6.05268 5.85355 6.14645C5.94732 6.24021 6 6.36739 6 6.5V12.5C6 12.6326 5.94732 12.7598 5.85355 12.8536C5.75979 12.9473 5.63261 13 5.5 13C5.36739 13 5.24021 12.9473 5.14645 12.8536C5.05268 12.7598 5 12.6326 5 12.5V6.5C5 6.36739 5.05268 6.24021 5.14645 6.14645C5.24021 6.05268 5.36739 6 5.5 6ZM8 6C8.13261 6 8.25979 6.05268 8.35355 6.14645C8.44732 6.24021 8.5 6.36739 8.5 6.5V12.5C8.5 12.6326 8.44732 12.7598 8.35355 12.8536C8.25979 12.9473 8.13261 13 8 13C7.86739 13 7.74021 12.9473 7.64645 12.8536C7.55268 12.7598 7.5 12.6326 7.5 12.5V6.5C7.5 6.36739 7.55268 6.24021 7.64645 6.14645C7.74021 6.05268 7.86739 6 8 6ZM11 6.5C11 6.36739 10.9473 6.24021 10.8536 6.14645C10.7598 6.05268 10.6326 6 10.5 6C10.3674 6 10.2402 6.05268 10.1464 6.14645C10.0527 6.24021 10 6.36739 10 6.5V12.5C10 12.6326 10.0527 12.7598 10.1464 12.8536C10.2402 12.9473 10.3674 13 10.5 13C10.6326 13 10.7598 12.9473 10.8536 12.8536C10.9473 12.7598 11 12.6326 11 12.5V6.5Z"
                :fill="color" />    
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M14.5 3.5C14.5 3.76522 14.3946 4.01957 14.2071 4.20711C14.0196 4.39464 13.7652 4.5 13.5 4.5H13V13.5C13 14.0304 12.7893 14.5391 12.4142 14.9142C12.0391 15.2893 11.5304 15.5 11 15.5H5C4.46957 15.5 3.96086 15.2893 3.58579 14.9142C3.21071 14.5391 3 14.0304 3 13.5V4.5H2.5C2.23478 4.5 1.98043 4.39464 1.79289 4.20711C1.60536 4.01957 1.5 3.76522 1.5 3.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H6C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5H9C9.26522 0.5 9.51957 0.605357 9.70711 0.792893C9.89464 0.98043 10 1.23478 10 1.5H13.5C13.7652 1.5 14.0196 1.60536 14.2071 1.79289C14.3946 1.98043 14.5 2.23478 14.5 2.5V3.5ZM4.118 4.5L4 4.559V13.5C4 13.7652 4.10536 14.0196 4.29289 14.2071C4.48043 14.3946 4.73478 14.5 5 14.5H11C11.2652 14.5 11.5196 14.3946 11.7071 14.2071C11.8946 14.0196 12 13.7652 12 13.5V4.559L11.882 4.5H4.118ZM2.5 3.5V2.5H13.5V3.5H2.5Z"
                :fill="color" />
        </g>
        <defs>
            <clipPath id="clip0_17177_46035">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#71767D',
        },
        size: {
            type: Number,
            default: 16,
        },
        hoverColor: {
            type: String,
            default: '#8869fd',
        },
    },
};
</script>

<style scoped>
.trash-can:hover path {
    fill: v-bind(hoverColor);
}
</style>
